import React from "react";
import "./LanguageButton.scss";
import { useLanguage } from "../contexts/LanguageContext";

const LanguageButton = () => {
  const { language, toggleLanguage } = useLanguage();
  const handleClick = (e) => {
    e.stopPropagation();
    toggleLanguage();
  };
  return (
    <div className="languageButton" onClick={handleClick}>
      {language === "fr" ? "E N" : "F R"}
    </div>
  );
};

export default LanguageButton;
